export const SESSION_ENDED_TOAST_ID = 'session-end';
export const SESSION_ENDED_TOAST = 'Your session has ended!';
export const DEFAULT_LANGUAGE_CODE = 'en-US';

export const SUCCESS_DIALOG = {
  PASSWORD_RESET: {
    TITLE: 'Password reset successful!',
    SUBTITLE: 'Your password has been updated successfully.',
    BUTTON_TEXT: 'Return to login',
  },
  FORM_SUBMISSION: {
    TITLE: 'Submission sent',
    SUBTITLE: {
      EXISTING_VENUE: `Your station placements have been submitted for admin review. You'll be notified once approved.`,
      NEW_VENUE: `Your venue and station placements have been submitted for admin review. You'll be notified once approved.`,
    },
    BUTTON_TEXT: 'Got it!',
  },
} as const;

export const WARNING_DIALOG = {
  VENUE_EXISTED: {
    TITLE: 'Venue already exists',
    CONTENT: `A venue with this name and address already exists. Please check your details or search for the existing venue to avoid duplication.`,
  },
  STATION_NOT_FOUND: {
    TITLE: 'Station not found',
    CONTENT: `The station you scanned is not registered to your account. If you believe this is an error, please contact support for assistance.`,
  },
} as const;

export enum ATTACHMENT_FIELD_NAME {
  imei = 'placement.attachment.imei',
  fullStationScreen = 'placement.attachment.fullStationScreen',
  stationLeftSide = 'placement.attachment.stationLeftSide',
  stationRightSide = 'placement.attachment.stationRightSide',
  stationFrontSide = 'placement.attachment.stationFrontSide',
  stationPerspective = 'placement.attachment.stationPerspective',
  additional = 'placement.attachment.additional',
}

export const REQUIRED_ATTACHMENTS = [
  {
    key: 'imei',
    caption: 'Close-up of IMEI',
    description: 'Full "IMEI: number” must be visible',
    fieldName: ATTACHMENT_FIELD_NAME.imei,
  },
  {
    key: 'fullStationScreen',
    caption: 'Close-up of full station’s screen',
    description: 'QR code must be visible',
    fieldName: ATTACHMENT_FIELD_NAME.fullStationScreen,
  },
  {
    key: 'stationLeftSide',
    caption: 'Wide view of station’s left side',
    description: 'Show placement & surroundings, about 5-10 ft away',
    fieldName: ATTACHMENT_FIELD_NAME.stationLeftSide,
  },
  {
    key: 'stationRightSide',
    caption: 'Wide view of station’s right side',
    description: 'Show placement & surroundings, about 5-10 ft away',
    fieldName: ATTACHMENT_FIELD_NAME.stationRightSide,
  },
  {
    key: 'stationFrontSide',
    caption: 'Wide view of station’s front side',
    description: 'Show placement & surroundings, about 5-10 ft away',
    fieldName: ATTACHMENT_FIELD_NAME.stationFrontSide,
  },
  {
    key: 'stationPerspective',
    caption: 'View from station’s perspective',
    description: 'What is the station facing?',
    fieldName: ATTACHMENT_FIELD_NAME.stationPerspective,
  },
  {
    key: 'additional',
    caption: 'Additional photo',
    description: '(optional)',
    fieldName: ATTACHMENT_FIELD_NAME.additional,
    optional: true,
  },
];

export const DEFAULT_COUNTRY_DATA = {
  name: 'United States',
  regions: ['america', 'north-america'],
  iso2: 'us',
  dialCode: '1',
  priority: 0,
  format: '+. (...) ...-....',
};

export const DEFAULT_PHONE_FORMAT = '... ... ...';
